import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { VueEditor } from 'vue2-editor';
let BaseTextField = class BaseTextField extends Vue {
    constructor() {
        super(...arguments);
        this.vueEditorCustomToolbar = [
            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ color: [] }, { background: [] }],
        ];
    }
    onPropertyChanged(value) {
        if (value.length > 0) {
            this.hasError = true;
        }
        else {
            this.hasError = false;
        }
    }
};
__decorate([
    Prop({ type: String, default: '' })
], BaseTextField.prototype, "label", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseTextField.prototype, "errorMessages", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseTextField.prototype, "hasError", void 0);
__decorate([
    Prop({ type: String, default: '' })
], BaseTextField.prototype, "value", void 0);
__decorate([
    Watch('errorMessages')
], BaseTextField.prototype, "onPropertyChanged", null);
BaseTextField = __decorate([
    Component({
        components: {
            VueEditor,
        },
    })
], BaseTextField);
export default BaseTextField;
